export const getPromocodesItems = (state) => state.promocodes.promocodes
export const getIsLoadingPromocoes = (state) => state.promocodes.isLoading
export const getPromocodesPagination = (state) => state.promocodes.pagination
